<template>
    <main id="mainCtrl">
        <TagSettingsDialog
            :speciality-options="this.serviceSpecialitiesDict"
            ref="serviceSettingsDialod"
        />
        <header>
            <button v-if="canEdit" @click="createService">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAANxSURBVHhe7ZxLqE1RGMevV4QQSpRHXqEUeRRRkhhQRoiJlIkod4RiwAAlBlKkmBAGMqBQDCgGlKIMyEAUKSmEvB+/T3e3v7tb69xz9jpnn3XO/n71G5z32v9zz1rf+vY5t8NoXwbhOpz+/5JREzPxGf7FH7gNjSrZgF9QwtOexYFoeOiHRzEbnPYRTkYjwxi8izqsT7gFH6jrxPe4Co0uFuMb1CE9xRkoDMDTqG//g/uwN5aaTvyJOpxLOASzbMZvqO97HUdg6RiMF1CH8Qt3Yi/0MQ9fon7cc5yNpWEqPkYdwltcitUwEm+ifvxX3IRtz2r8iPrg7+NYrIU+eABlLtTPdQL7Y9vRqAN2vSH3sNY3JGoa/ZELnRKiZi4WMen7FqUdWGlRippmlB1SFsneWb+mryyKFil8T6E+iCILX1dh/gRboqszHmPYevm2hmsxWpbjO9SDls3/JGwGruaEfBIOY1+MBpmkd6NM2nqwsbSfXO2xWzgKm85QvIx6cDKJb8WY0A3axFe4AJuGb1ALMUaG4RXU4/2OTXmz1+Nn1IO5jVF8LCrgm27OYCHTjW9iPoJRTcw9sAKzC95DnIgNYzTeQf2i0ZcGFfCVXCux7viK06Rr3Kq4ut2/cS/Wrejfji2/PeoB17bzGg7H3MgG/TzqJ235DXoFfN3uWVgzU7BtW0QV8LXeNmLVuJqUskK1VZOyAtL8lapCH7/YY/PX1zUWD2KZkE1CNgPRe/pBisgb6HqQaAGmylQ2H7shOwt9J5k8Je3kcpEBTsBlDhdhUWQDzHa7r2I3ZKWRfaHcKF1jWb7PdV0WiwxwFyavq5UVsiiyAQr6SwD75YossvIuwaREsQBTE6S3qTOqiAWYmgsLMDUXFmBqLizA1FxYgKm5sABTc2EBpubCAkzNRT0DlDaRnG+oxkOoB5/4Gl33dynbwRCiC/A46gE12g8YggWIIViAGIIFiCFYgBiCBYghRBfgOJxTpcdQDz5RTuy77u8y16lIRXQB1oIV0oFYgIFYgIFYgIFYgIFYgIFYgIFYgIFYgIFYgIFMwzUOG/Llbw8tHWAMWICBWICBWICBWICBWICBWICBWICBWICBWICB1D1A+anXyRJ5EesaYNnNhfyYxPVkZfMF5kL+EfYedP2Jl0X5/xAyHxqGYRhGveno+AeEC0bs4pPXqgAAAABJRU5ErkJggg=="
                     width="25"
                     height="25"
                >
                <span>
                    Добавить услугу
                </span>
            </button>
        </header>
        <v-table id="table"
                 :showEye="false"
                 request-uri="services/getList"
                 pagesize="100"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th sort="id"  name="char_id">
                       <span>Char_id</span>
                    </v-th>
                    <v-th name="type">
                        <span>type</span>
                    </v-th>
                    <v-th  sort="name" name="name">
                        <span>Name</span>
                    </v-th>
                    <v-th sort="name_slug"  name="name_slug">
                        <span>URL</span>
                    </v-th>
                    <v-th name="doctorSpecialities_id">
                        <span>Специальности</span>
                    </v-th>
                    <v-th name="name_info">
                        <span>NameInfo</span>
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="char_id" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="type" v-slot="{filter}">
                        <v-select v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "SERVICE",
                                    text: "SERVICE"
                                },
                                {
                                    value: "DIAGNOSTIC",
                                    text: "DIAGNOSTIC"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="name" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="name_slug" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="doctorSpecialities_id">
                    </v-th>
                    <v-th name="name_info" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td>
                        <span>{{ item.char_id }}</span>
                    </v-td>
                    <v-td>
                        <span>{{ item.type }}</span>
                    </v-td>
                    <v-td>
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td>
                        <span>{{ item.name_slug }}</span>
                    </v-td>
                    <v-td>
                        <span class="comma">
                            <span v-for="sepciality in item.doctorSpecialities">
                                {{ sepciality.name }}
                            </span>
                        </span>
                    </v-td>
                    <v-td>
                        <i class="fas fa-square" v-if="item.name_info.singular.nominative != ''" :tooltip="item.name_info.singular.nominative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.singular.genitive != ''" :tooltip="item.name_info.singular.genitive" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.singular.dative != ''" :tooltip="item.name_info.singular.dative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.singular.accusative != ''" :tooltip="item.name_info.singular.accusative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.singular.ablative != ''" :tooltip="item.name_info.singular.ablative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.singular.prepositional != ''" :tooltip="item.name_info.singular.prepositional" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>

                        <i class="fas fa-square" v-if="item.name_info.plural.nominative != ''" :tooltip="item.name_info.plural.nominative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.plural.genitive != ''" :tooltip="item.name_info.plural.genitive" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.plural.dative != ''" :tooltip="item.name_info.plural.dative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.plural.accusative != ''" :tooltip="item.name_info.plural.accusative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.plural.ablative != ''" :tooltip="item.name_info.plural.ablative" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                        <i class="fas fa-square" v-if="item.name_info.plural.prepositional != ''" :tooltip="item.name_info.plural.prepositional" style="width: 11px"></i><i v-else class="far fa-square" style="width: 11px"></i>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
    import TagSettingsDialog from "@dialogs/admin/settings/tags/Tag";
    export default {
        name: "ServiceSettings",
        components: {
            TagSettingsDialog,
        },
        props: {
            serviceSpecialitiesDict: { required: true }
        },
        mounted() {
            this.checkIncomingId();
        },
        computed: {
            canEdit() {
                return this.$canAny(['admin.settings.services.update'])
            },
        },
        methods: {
            checkIncomingId () {
                let openId = this.$root.getQueryVariable('openId');
                if (openId !== null){
                    this.$refs.serviceSettingsDialod.read(openId)
                }
            },
            handleRowClick: function (event, row, item) {
                row.startLoadingAnimation();
             return   this.$refs.serviceSettingsDialod.read(item.id).then(
                () => row.stopLoadingAnimation(), () => row.stopLoadingAnimation());
            },
            createService () {
                this.$refs.serviceSettingsDialod.open();
            },
            updateTable() {
                this.$refs.table.update();
            }
        }
    }
</script>

<style scoped>

</style>
